/**
 * Tryb katalogowy: sklep pokazuje ofertę, ale niczego nie sprzedaje.
 *
 * Włączany runtime'owo przez NUXT_PUBLIC_CATALOG_ONLY=true, per instalacja —
 * lavmag i youlook mają go wyłączony i nie zmienia się dla nich nic.
 *
 * Twardą blokadą jest backend (CONTELIZERREST_CATALOG_ONLY → 403 na koszyku,
 * checkoucie, płatnościach, zamówieniach i koncie). Front nie może być jedyną
 * barierą, bo endpointy są publiczne — ale musi być spójny z backendem, żeby
 * użytkownik nie klikał w ścieżki kończące się błędem.
 *
 * Reguła trasy trzymana tutaj, a nie w middleware, bo to jedyna część tej
 * funkcji, którą da się przetestować bez uruchamiania Nuxta.
 */

/**
 * Ścieżki, których w sklepie katalogowym nie ma. Odpowiadają katalogom
 * kontrolerów zablokowanych po stronie API (Cart, Checkout, Order, Account,
 * Address, Auth) — rozjazd między tymi listami oznaczałby stronę, która się
 * otwiera i dopiero potem dostaje 403.
 *
 * `/favorites` jest tu, mimo że nie jest zakupem: lista życzeń czyta wishlist
 * z backendu, więc w trybie katalogowym pokazałaby wyłącznie błąd.
 */
export const CATALOG_ONLY_BLOCKED_ROUTES = [
  '/cart',
  // Odzyskanie koszyka z maila — dopasowanie po segmencie nie łapie go pod `/cart`.
  '/cart-recover',
  '/checkout',
  '/account',
  '/auth',
  '/zamowienie',
  '/thank-you',
  '/sledzenie-zamowienia',
  '/favorites',
] as const

/** Etykieta zastępująca „Do koszyka" w całym interfejsie. */
export const CATALOG_ONLY_CTA_LABEL = 'Zapytaj o wycenę'

/**
 * Czy ścieżka należy do wyłączonej ścieżki zakupowej?
 *
 * Dopasowanie jest po SEGMENCIE, nie po prefiksie tekstowym: `/cart` blokuje
 * `/cart` i `/cart/coupons`, ale nie `/cartridge` ani `/accountancy` — inaczej
 * tryb katalogowy potrafiłby ukryć kategorię produktów o niefortunnej nazwie.
 */
export function isCatalogOnlyBlockedRoute(path: string): boolean {
  const normalized = normalizePath(path)

  if (normalized === '') return false

  return CATALOG_ONLY_BLOCKED_ROUTES.some(
    (blocked) => normalized === blocked || normalized.startsWith(`${blocked}/`),
  )
}

/**
 * Ścieżka bez parametrów zapytania, kotwicy i końcowego ukośnika, w małych
 * literach. Nuxt potrafi oddać `/Cart?step=1#top`, a middleware musi widzieć
 * dokładnie to samo co lista wyżej.
 */
function normalizePath(path: string): string {
  if (!path) return ''

  const withoutQuery = path.split('?')[0]?.split('#')[0] ?? ''
  const lowered = withoutQuery.toLowerCase()
  const trimmed = lowered.length > 1 ? lowered.replace(/\/+$/, '') : lowered

  return trimmed === '/' ? '/' : trimmed
}
